import { Box, Grid } from '@mui/material'
import { makeStyles } from '@material-ui/core/styles'
import BikeAnimation from 'src/components/BuyPolicy/insuranceScreens/bike/BikeAnimation'
import BikeDetails from 'src/components/BuyPolicy/insuranceScreens/bike/BikeDetails'
import BikeFundamental from 'src/components/BuyPolicy/insuranceScreens/bike/BikeFundamental'
import BikeRoadSafety from 'src/components/BuyPolicy/insuranceScreens/bike/BikeRoadSafety'
import BikeInsuranceType from 'src/components/BuyPolicy/insuranceScreens/bike/BikeInsuranceType'
import BikeComparison from 'src/components/BuyPolicy/insuranceScreens/bike/BikeComparison'
import InsuranceCovers from 'src/components/BuyPolicy/common/InsuranceCovers'
import WhyConsiderTrovity from 'src/components/BuyPolicy/common/WhyConsiderTrovity'
import {
  addOnCoversList,
  insuranceCoverHeading,
  insuranceCoverHeadingText,
} from 'src/utils/constants/BuyPolicyBike'

const Bike = () => {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <Grid container spacing={0} direction='column'>
        <Grid item xs={12}>
          <BikeDetails />
        </Grid>
        <Grid item xs={12}>
          <BikeAnimation />

          <Box className={classes.featuresSection}>
            <BikeFundamental />

            <BikeRoadSafety />
          </Box>
          <Box className={classes.featuresSection}>
            <BikeInsuranceType />
          </Box>
          <Box className={classes.featuresSectionComparison}>
            <BikeComparison />
          </Box>
          <Box className={classes.featuresSection}>
            <InsuranceCovers
              heading={insuranceCoverHeading}
              headingText={insuranceCoverHeadingText}
              addOnCoversList={addOnCoversList}
            />
          </Box>
          <Box className={classes.featuresSection}>
            <WhyConsiderTrovity insuranceName={'bike'} />
          </Box>
        </Grid>
      </Grid>
    </div>
  )
}

export default Bike

const useStyles = makeStyles({
  container: {
    flexGrow: 1,
    width: '100%',
  },
  featuresSectionComparison: {
    '@media (max-width:1024px)': {
      display: 'none',
    },
  },
})
